import React from 'react';
import PropTypes from 'prop-types';
import { useSignatureFonts } from './useSignatureFonts';
import './FontSelector.scss';
import { CheckIcon } from './Icons';

export default function FontSelector(props) {
  const fonts = useSignatureFonts();

  return (
    <div className="font-selector">
      {fonts.map(font => (
        <div
          key={font.name}
          className="font-item"
          style={{ fontSize: '18px', fontFamily: font.fontFamily }}
          onClick={() => props.onSelect(font.name)}
          tabIndex="-1"
        >
          {props.selectedFont === font.name ? <CheckIcon /> : null}
          <span>{props.previewText || font.name}</span>
        </div>
      ))}
    </div>
  );
}

FontSelector.propTypes = {
  selectedFont: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  previewText: PropTypes.string,
};
